import {
    ANNUAL_MILEAGE_OPTIONS, CAR_INSURANCE_COVERAGE_TYPE_OPTIONS,
    CAR_OWNER_TYPE_OPTIONS,
    insurancePaymentTypes, NO_CLAIMS_DISCOUNT_OPTIONS, PARKING_DURING_NIGHT_OPTIONS,
    PARKING_DURING_DAY_OPTIONS, CAR_USAGE_TYPE_OPTIONS,
    YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";
import {format} from "date-fns";

export const ValidateStep3Data = (data) => {

    let rules = [
        {
            field_name: 'isCarRegistrationNumKnown',
            field_label: 'Do you know car registration number?',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Please specify if you know the car registration number'
                }
            ]
        },
        {
            field_name: 'carRegistrationNumber',
            field_label: 'Car Registration number',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'isCarRegistrationNumKnown',
                        value: 'Yes'
                    },
                    message: 'Car registration number is required'
                },
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: 50
                    },
                    message: 'Car registration number cannot be longer than {length} characters'
                }
            ]
        },
        {
            field_name: 'hasModifications',
            field_label: 'Has Modifications',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if the car has modifications'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid car modifications choice: {value}'
                }
            ]
        },
        {
            field_name: 'modificationType',
            field_label: 'Modification Type',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'hasModifications',
                        value: 'Yes'
                    },
                    message: 'Please specify the modification type'
                },
                {name: 'string'},
            ]
        },
        {
            field_name: 'modificationDetails',
            field_label: 'Modification Details',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'hasModifications',
                        value: 'Yes'
                    },
                    message: 'Please provide the modification details'
                },
            ]

        },
        {
            field_name: 'wasCarImported',
            field_label: 'Was the car imported?',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if the car was imported'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for car imported status: {value}'
                }
            ]
        },
        {
            field_name: 'carPurchased',
            field_label: 'Car Purchased',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if you purchased the car'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for car purchased status: {value}'
                }
            ]
        },
        {
            field_name: 'carPurchaseDate',
            field_label: 'Car Purchase date',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'carPurchased',
                        value: 'Yes'
                    },
                    message: 'Please provide the car purchase date'
                },
                {
                    name: 'date_string', data: {
                        format: 'yyyy-MM-dd'
                    }
                },
            ]
        },
        {
            field_name: 'registeredKeeper',
            field_label: 'Registered keeper',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify the registered keeper'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: CAR_OWNER_TYPE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for registered keeper: {value}'
                }
            ]
        },
        {
            field_name: 'legalOwner',
            field_label: 'Legal owner',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify the legal owner'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: CAR_OWNER_TYPE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for legal owner: {value}'
                }
            ]
        },
        {
            field_name: 'carImpoundedWithPolice',
            field_label: 'Is the car impounded with police?',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if the car is impounded with police'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for car impounded with police status: {value}'
                }
            ]
        },
        {
            field_name: 'carParkingAtDay',
            field_label: 'Car Parking At Day',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify where the car is parked during the day'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: PARKING_DURING_DAY_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for car parking at day: {value}'
                }
            ]
        },
        {
            field_name: 'carParkingAtNight',
            field_label: 'Car Parking At Night',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify where the car is parked during the night'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: PARKING_DURING_NIGHT_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for car parking at night: {value}'
                }
            ]
        },
        {
            field_name: 'isCarKeptOnSameAddress',
            field_label: 'Is the vehicle kept at the same address?',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if the vehicle is kept at the same address'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for is car kept on same address status: {value}'
                }
            ]
        },
        {
            field_name: 'vehicleKeeperAddress',
            field_label: 'Vehicle Keeper Address',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'isCarKeptOnSameAddress',
                        value: 'No'
                    },
                    message: 'Please provide the full address of where the vehicle is kept'
                },
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: 500
                    },
                    message: 'Vehicle keeper address cannot be longer than {length} characters'
                }
            ]
        },
        {
            field_name: 'wasInsuranceDeclinedBefore',
            field_label: 'Was insurance declined before?',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if insurance was declined before'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for was insurance declined before status: {value}'
                }
            ]
        },
        {
            field_name: 'insurerName',
            field_label: 'Insurer Name',
            rules: [
                {
                    name: 'required_if_target_equals',
                    data: {
                        target_field: 'wasInsuranceDeclinedBefore',
                        value: 'Yes'
                    },
                    message: 'Please provide the name of insurer'
                },
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: 100
                    },
                    message: 'Insurer name cannot be longer than {length} characters'
                }
            ]
        },
        {
            field_name: 'vehicleUsageType',
            field_label: 'Vehicle usage Type',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify the vehicle usage type'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: CAR_USAGE_TYPE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for vehicle usage type: {value}'
                }
            ]
        },
        {
            field_name: 'estimatedAnnualMileage',
            field_label: 'Estimated annual mileage',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify the estimated annual mileage'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: ANNUAL_MILEAGE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for estimated annual mileage: {value}'
                }
            ]
        },
        {
            field_name: 'insuranceCoverageType',
            field_label: 'Insurance Coverage Type',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify the insurance coverage type'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: CAR_INSURANCE_COVERAGE_TYPE_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for insurance coverage type: {value}'
                }
            ]
        },
        {
            field_name: 'noClaimsDiscount',
            field_label: 'No Claims Discount',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify if you have any no claims discount'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: NO_CLAIMS_DISCOUNT_OPTIONS?.map(item => item.value)
                    },
                    message: 'Invalid choice for no claims discount status: {value}'
                }
            ]
        },
        {
            field_name: 'insurancePaymentType',
            field_label: 'Insurance Payment Type',
            rules: [
                {
                    name: 'required',
                    message: 'Please specify how you normally pay for insurance'
                },
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: insurancePaymentTypes?.map(item => item.value)
                    },
                    message: 'Invalid choice for insurance payment type: {value}'
                }
            ]
        },
        {
            field_name: 'insuranceCoverageStartDate',
            field_label: 'Insurance Coverage Start Date',
            rules: [
                {
                    name: 'required',
                    message: 'Please provide the insurance coverage start date'
                },
                {
                    name: 'date_string', data: {
                        format: 'yyyy-MM-dd'
                    },
                    message: 'Insurance coverage start date must be a valid date'
                },
                {
                    name: 'date_string_after',
                    data : {
                        format: 'yyyy-MM-dd',
                        date : format(new Date(), 'yyyy-MM-dd'),
                    },
                    message: 'Insurance coverage start date must be today or a future date'
                }
            ]
        }

    ];

    const validator = new ObjetDataValidator({
        data,
        rules
    });

    const result = validator.validate();

    if (result === true) {
        return [];
    } else {
        return transformValidationResultToArray(result);
    }

}